import { Button, Tooltip, GlanceLoader } from '../ui-components';
import React from 'react';

function InitialState({onEnterKey, onMCS, gicon}) {

  return (
    <>
      <div className="SizeWrapper">
        <div className="rowAlign">
          { gicon && <GlanceLoader size="12" spinning={false}></GlanceLoader> }
          <span className="wrapper">
          <Tooltip text="Customer’s key request" offset={8} size="small">
            <Button
              size="small"
              variant="primary"
              shape="rounded-full"
              animation={false}
              onClick={() => (typeof(onEnterKey) === typeof(Function)) ? onEnterKey() : console.log('EK pressed')}
            >
              Enter key
            </Button>
            </Tooltip>
          </span>

          <span className="wrapper">
            <Tooltip text="Send link to customer’s phone" offset={8} size="small"> 
            <Button
              size="small"
              variant="tertiary"
              shape="rounded-full"
              animation={false}
              onClick={() => (typeof(onMCS) === typeof(Function)) ? onMCS() : console.log('MCS pressed')}
            >
              Camera Share
            </Button>
            </Tooltip>
          </span>
        </div>
      </div>
    </>
  );
}

export default InitialState;
